import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createBrowserRouter, RouterProvider } from 'react-router';
import { GlobalEffects } from './components/Effects';
import { Layout } from './components/Layout';
import { LandingPage } from './pages/LandingPage';
import { MerchantOnboardingReturnPage } from './pages/MerchantOnboardingReturnPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { RecordingsListPage } from './pages/RecordingsListPage';
import { SharePage } from './pages/SharePage';
import { StreamrAppEmbedPage } from './pages/StreamrAppEmbedPage';
import { StreamrAppPage } from './pages/StreamrAppPage';
import { UnhandledErrorPage } from './pages/UnhandledErrorPage';
const router = createBrowserRouter([
    {
        element: _jsx(Layout, {}),
        errorElement: (_jsx(Layout, { children: _jsx(UnhandledErrorPage, {}) })),
        children: [
            {
                path: '/',
                element: _jsx(LandingPage, {}),
            },
            {
                path: '/stream/:streamId',
                element: _jsx(StreamrAppPage, {}),
            },
            {
                path: '/recordings/:streamId',
                element: _jsx(RecordingsListPage, {}),
            },
            {
                path: '/merchant-onboarding-return',
                element: _jsx(MerchantOnboardingReturnPage, {}),
            },
            {
                path: '*',
                element: _jsx(NotFoundPage, {}),
            },
        ],
    },
    {
        path: '/embed/:streamId',
        element: _jsx(StreamrAppEmbedPage, {}),
    },
    {
        path: '/share',
        element: _jsx(SharePage, {}),
    },
]);
export function App() {
    return (_jsxs(_Fragment, { children: [_jsx(GlobalEffects, {}), _jsx(RouterProvider, { router: router })] }));
}
